
  var style = require("icon-maker-loader/.tmp/28e27980-db16-4011-8a4d-a9e26dfc90be/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-add"];
  } else {
    module.exports = "icon-maker icon-maker-add";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/add.svg
// module id = 528
// module chunks = 5